import { render, staticRenderFns } from "./NoteAdditionnelle.vue?vue&type=template&id=e5c67420&scoped=true"
import script from "./NoteAdditionnelle.vue?vue&type=script&lang=js"
export * from "./NoteAdditionnelle.vue?vue&type=script&lang=js"
import style0 from "./NoteAdditionnelle.vue?vue&type=style&index=0&id=e5c67420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c67420",
  null
  
)

export default component.exports